var getLocalStorageItem = function getLocalStorageItem(key, logger) {
  try {
    var item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    var errorMessage = "Error getting item from localStorage";
    logger ? logger.warning(errorMessage, {
      contextData: {}
    }) : console.warn(errorMessage);
    return null;
  }
};
var setLocalStorageItem = function setLocalStorageItem(key, value, logger) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    var errorMessage = "Error setting item from localStorage";
    logger ? logger.warning(errorMessage, {
      contextData: {}
    }) : console.warn(errorMessage);
  }
};

export { getLocalStorageItem, setLocalStorageItem };
//# sourceMappingURL=localStorage.js.map
